'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSimple = isSimple;
exports.hoistRef = hoistRef;
exports.undeclaredRef = undeclaredRef;

var _is = require('./is');

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _getLoc = require('ast-loc-utils/lib/getLoc');

var _getLoc2 = _interopRequireDefault(_getLoc);

var _buildAtLoc = require('ast-loc-utils/lib/buildAtLoc');

var _buildAtLoc2 = _interopRequireDefault(_buildAtLoc);

var _placeAtLoc = require('ast-loc-utils/lib/placeAtLoc');

var _placeAtLoc2 = _interopRequireDefault(_placeAtLoc);

var _span = require('ast-loc-utils/lib/span');

var _span2 = _interopRequireDefault(_span);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSimple(refTarget) {
  return (0, _is.isa)(refTarget, "Identifier") || (0, _is.isa)(refTarget, "ThisExpression");
} // Hoist a ref up to the enclosing scope if needed.
function hoistRef(path, refTarget) {
  var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ref";

  if (isSimple(refTarget)) {
    return { ref: refTarget, assign: refTarget, isComplex: false };
  } else {
    var ref = path.scope.generateDeclaredUidIdentifier(varName);
    var loc = (0, _getLoc2.default)(refTarget);
    (0, _placeAtLoc2.default)(ref, (0, _span2.default)(loc, 1));
    return {
      ref,
      assign: (0, _buildAtLoc2.default)(loc, _types2.default.assignmentExpression, "=", ref, refTarget),
      isComplex: true
    };
  }
} // Create a variable declarator for a ref in the enclosing scope, if
// needed
function undeclaredRef(path, refTarget) {
  var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ref";

  if (isSimple(refTarget)) {
    return { ref: refTarget, declarator: null, isComplex: false };
  } else {
    var ref = path.scope.generateUidIdentifier(varName);
    var loc = (0, _getLoc2.default)(refTarget);
    (0, _placeAtLoc2.default)(ref, (0, _span2.default)(loc, 1));
    return {
      ref,
      declarator: (0, _buildAtLoc2.default)(loc, _types2.default.variableDeclarator, ref, refTarget),
      isComplex: true
    };
  }
}